import React from "react"

import Trabajadores from "@images/blockIcons/trabajadores.png"
import Empleados from "@images/blockIcons/empleados.png"
import Provedores from "@images/blockIcons/provedores.png"
import Empresas from "@images/blockIcons/empresas.png"
import Organos from "@images/blockIcons/organos.png"
import Administracion from "@images/blockIcons/administracion.png"
import Asesorias from "@images/blockIcons/asesorias.png"
import Sect from "@images/blockIcons/sect.png"
import Sociedad from "@images/blockIcons/sociedad.png"

const BlockIcons = ({text}) => {
  return (
    <div className="icons-container">
      <div className="icon">
        <img src={Trabajadores} alt=""></img>
        <div className="icon-text">{text[0]}</div>
      </div>
      <div className="icon">
        <img src={Empleados} alt=""></img>
        <div className="icon-text">{text[1]}</div>
      </div>
      <div className="icon">
        <img src={Provedores} alt=""></img>
        <div className="icon-text">{text[2]}</div>
      </div>
      <div className="icon">
        <img src={Empresas} alt=""></img>
        <div className="icon-text">{text[3]}</div>
      </div>
      <div className="icon">
        <img src={Organos} alt=""></img>
        <div className="icon-text">{text[4]}</div>
      </div>
      <div className="icon">
        <img src={Administracion} alt=""></img>
        <div className="icon-text">{text[5]}</div>
      </div>
      <div className="icon">
        <img src={Asesorias} alt=""></img>
        <div className="icon-text">{text[6]}</div>
      </div>
      <div className="icon">
        <img src={Sect} alt=""></img>
        <div className="icon-text">{text[7]}</div>
      </div>
      <div className="icon">
        <img src={Sociedad} alt=""></img>
        <div className="icon-text">{text[8]}</div>
      </div>
    </div>
  )
}

export default BlockIcons
